import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    photos: [
    //   { id: 1, path: require('../assets/img/lb/感恩节活动.jpg'), text: '感恩节活动' },
    //   { id: 21, path: require('../assets/img/lb/2小年下午茶歇.jpg'), text: '小年下午茶歇' },
    //   { id: 23, path: require('../assets/img/lb/4女王节礼品派发.jpg'), text: '女王节礼品派发' },
    //   { id: 22, path: require('../assets/img/lb/3六一活动零食区.jpg'), text: '六一活动零食区' },
    //   { id: 24, path: require('../assets/img/lb/部门活动聚餐.jpg'), text: '部门活动聚餐' },
    //   { id: 3, path: require('../assets/img/lb/年会歌舞之海芋恋min.jpg'), text: '年会歌舞之海芋恋' },
    //   { id: 4, path: require('../assets/img/lb/年会爆笑小品之办公室风波.jpg'), text: '年会爆笑小品之办公室风波' },
    //   { id: 5, path: require('../assets/img/lb/年会舞蹈之新年happymin.jpg'), text: '年会舞蹈之新年happy' },
    //   { id: 6, path: require('../assets/img/lb/年度优秀部门之出游日本-min.jpg'), text: '年度优秀部门之出游日本' },
    //   { id: 25, path: require('../assets/img/lb/年度优秀部门之成都出游.jpg'), text: '年度优秀部门之成都出游' },
    //   { id: 26, path: require('../assets/img/lb/年度优秀部门之杭州出游.jpg'), text: '年度优秀部门之杭州出游' },
    //   { id: 27, path: require('../assets/img/lb/年度优秀部门之张家界出游.jpg'), text: '年度优秀部门之张家界出游' },
      
    //   { id: 7, path: require('../assets/img/lb/春游巨龙湖之水战王者-min.jpg'), text: '春游巨龙湖之水战王者' },
    //   { id: 8, path: require('../assets/img/lb/秋游之cs射击对战-min.jpg'), text: '秋游之cs射击对战' },
    // //   { id: 9, path: require('../assets/img/lb/趣味运动会之指压板跳绳-min.jpg'), text: '趣味运动会之指压板跳绳' },

    //   { id: 28, path: require('../assets/img/lb/趣味运动会之仰卧起坐.jpg'), text: '趣味运动会之仰卧起坐' },
    //   { id: 29, path: require('../assets/img/lb/趣味运动会之趾压板跳绳.jpg'), text: '趣味运动会之趾压板跳绳' },
    //   { id: 10, path: require('../assets/img/lb/趣味运动会之障碍接力-min.jpg'), text: '趣味运动会之障碍接力' },
    //   { id: 11, path: require('../assets/img/lb/趣味运动会之绑腿接力-min.jpg'), text: '趣味运动会之绑腿接力' },
    //   { id: 2, path: require('../assets/img/lb/夏季海岛游之撕名牌min.jpg'), text: '夏季海岛游之撕名牌' },
    //   { id: 12, path: require('../assets/img/lb/部门活动之爬山赏花-min.jpg'), text: '部门活动之爬山赏花' },
    //   { id: 13, path: require('../assets/img/lb/阅览区.jpg'), text: '阅览区' },
    //   { id: 14, path: require('../assets/img/lb/阅览区2.jpg'), text: '阅览区' },
    //   { id: 15, path: require('../assets/img/lb/茶水间.jpg'), text: '茶水间' },
    //   { id: 16, path: require('../assets/img/lb/会议室1.jpg'), text: '会议室' },
    //   { id: 17, path: require('../assets/img/lb/培训室.jpg'), text: '培训室' },
    //   { id: 18, path: require('../assets/img/lb/办公区3.jpg'), text: '办公区' },
    //   { id: 19, path: require('../assets/img/lb/办公区2.jpg'), text: '办公区' },
    //   { id: 20, path: require('../assets/img/lb/办公区1.jpg'), text: '办公区' }
    ],
    jobList: [],
    detaildid: null,
    jobNav: [],
    commonData: {},

    sourceList: [], // 来源下拉列表
  },
  mutations: {
    setJobList(state, payload) {
      state.jobList = payload
    },
    setDetailid(state, payload) {
      state.detaildid = payload
    },
    setJobNav(state, payload) {
      state.jobNav = payload
    },
    setCommonData(state, payload) {
      state.commonData = payload
    },
    setSourceList(state, payload) {
      state.sourceList = payload
    },
  },
  actions: {
  },
  modules: {
  }
})
